// extracted by mini-css-extract-plugin
module.exports = {"date":"TextInput_date__dO13p"};